import { render } from "./News_index_m.vue?vue&type=template&id=7e2a1030&scoped=true"
import script from "./News_index_m.vue?vue&type=script&lang=js"
export * from "./News_index_m.vue?vue&type=script&lang=js"

import "./News_index_m.vue?vue&type=style&index=0&id=7e2a1030&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e2a1030"

export default script